(function () {
  if (window.__AG_PB_PD_CLINICAL_MODAL_INIT__) return;
  window.__AG_PB_PD_CLINICAL_MODAL_INIT__ = true;

  var openModals = [];

  function getFocusable(root) {
    if (!root) return [];
    return Array.prototype.slice.call(
      root.querySelectorAll(
        'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter(function (el) {
      return !el.hasAttribute('hidden') && el.offsetParent !== null;
    });
  }

  function lockScroll(lock) {
    if (lock) {
      document.documentElement.classList.add('ag-pb-pd-clinical-modal-open');
      document.body.classList.add('ag-pb-pd-clinical-modal-open');
    } else if (!openModals.length) {
      document.documentElement.classList.remove('ag-pb-pd-clinical-modal-open');
      document.body.classList.remove('ag-pb-pd-clinical-modal-open');
    }
  }

  function closeModal(modal) {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    modal.classList.remove('is-open');
    openModals = openModals.filter(function (m) { return m !== modal; });
    lockScroll(false);

    var opener = modal.__agPbPdClinicalOpener;
    modal.__agPbPdClinicalOpener = null;
    if (opener && typeof opener.focus === 'function') {
      try { opener.focus(); } catch (e) { /* ignore */ }
    }
  }

  function openModal(modal, opener) {
    if (!modal) return;
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }
    modal.hidden = false;
    modal.classList.add('is-open');
    modal.__agPbPdClinicalOpener = opener || null;
    if (openModals.indexOf(modal) === -1) openModals.push(modal);
    lockScroll(true);

    var closeBtn = modal.querySelector('[data-ag-pb-pd-clinical-close]');
    var focusTarget = closeBtn || getFocusable(modal)[0] || modal;
    window.requestAnimationFrame(function () {
      try { focusTarget.focus(); } catch (e) { /* ignore */ }
    });
  }

  function bindModal(modal) {
    if (!modal || modal.dataset.agPbPdClinicalBound === 'true') return;
    modal.dataset.agPbPdClinicalBound = 'true';

    modal.addEventListener('click', function (e) {
      var t = e.target;
      if (!t) return;
      if (t.closest('[data-ag-pb-pd-clinical-close]')) {
        e.preventDefault();
        closeModal(modal);
      }
    });

    modal.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        closeModal(modal);
        return;
      }
      if (e.key !== 'Tab') return;
      var focusable = getFocusable(modal);
      if (!focusable.length) {
        e.preventDefault();
        return;
      }
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  }

  function bindOpen(btn) {
    if (!btn || btn.dataset.agPbPdClinicalOpenBound === 'true') return;
    btn.dataset.agPbPdClinicalOpenBound = 'true';

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var id = btn.getAttribute('aria-controls');
      var modal = id ? document.getElementById(id) : null;
      if (!modal) {
        var host = btn.closest('.ag-pb-pd__clinical, .ag-pb-clinical-trial, .js-ag-pb-clinical-trial');
        var next = host && host.nextElementSibling;
        if (next && next.hasAttribute('data-ag-pb-pd-clinical-modal')) modal = next;
        if (!modal && host) {
          modal = host.querySelector('[data-ag-pb-pd-clinical-modal]');
        }
      }
      if (!modal) return;
      bindModal(modal);
      openModal(modal, btn);
    });
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(
      scope.querySelectorAll('[data-ag-pb-pd-clinical-open], .js-ag-pb-pd-clinical-open'),
      bindOpen
    );
    Array.prototype.forEach.call(scope.querySelectorAll('[data-ag-pb-pd-clinical-modal]'), bindModal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e && e.target ? e.target : document);
  });
})();
